import { useWatch } from 'react-hook-form';
import type {
  InputTableCellParams,
  InputTableRowParams,
  RepeatRowsPayload,
  TableSelectedCell
} from '@/components/custom/erp';
import type { DetailItemRow } from './tabs/hooks/useDetailItemRows';
import type { FormMode } from '@/types/form';
import { DetailItemTab } from './tabs';

interface DetailItemTabWrapperProps {
  formMode: FormMode;
  detailRows: DetailItemRow[];
  detailSelectedRowUuid?: string | null;
  detailSelectedCell?: TableSelectedCell | null;
  detailHandleRowClick?: (params: InputTableRowParams<DetailItemRow>) => void;
  detailHandleCellClick?: (params: InputTableCellParams) => void;
  detailHandleAddRow: () => void;
  detailHandleDeleteRow: () => void;
  detailHandleCopyRow: () => void;
  detailHandlePasteRow: (clipboardText?: string) => void | Promise<void>;
  detailHandleMoveRow: (direction: 'up' | 'down') => void;
  detailHandleCellValueChange: (rowUuid: string, field: string, newValue: unknown) => void;
  detailHandleUpdateNonWritableFields?: (fields: Set<string>) => void;
  detailHandleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<unknown[]>; resultField?: string }>
  ) => void;
  onRepeatForRows: (payload: RepeatRowsPayload<DetailItemRow>) => void;
  isPasting?: boolean;
}

export const DetailItemTabWrapper = ({
  formMode,
  detailRows,
  detailSelectedRowUuid,
  detailSelectedCell,
  detailHandleRowClick,
  detailHandleCellClick,
  detailHandleAddRow,
  detailHandleDeleteRow,
  detailHandleCopyRow,
  detailHandlePasteRow,
  detailHandleMoveRow,
  detailHandleCellValueChange,
  detailHandleUpdateNonWritableFields,
  detailHandleUpdatePasteConfigs,
  onRepeatForRows,
  isPasting
}: DetailItemTabWrapperProps) => {
  const [ma_ngv, dien_giai] = useWatch({ name: ['ma_ngv', 'dien_giai'] });

  return (
    <DetailItemTab
      formMode={formMode}
      rows={detailRows}
      selectedRowUuid={detailSelectedRowUuid}
      selectedCell={detailSelectedCell}
      onRowClick={detailHandleRowClick}
      onCellClick={detailHandleCellClick}
      onAddRow={detailHandleAddRow}
      onDeleteRow={detailHandleDeleteRow}
      onCopyRow={detailHandleCopyRow}
      onPasteRow={detailHandlePasteRow}
      onMoveRow={detailHandleMoveRow}
      onCellValueChange={detailHandleCellValueChange}
      onRepeatForRows={onRepeatForRows}
      ma_ngv={ma_ngv || '1'}
      dien_giai={dien_giai}
      handleUpdateNonWritableFields={detailHandleUpdateNonWritableFields}
      handleUpdatePasteConfigs={detailHandleUpdatePasteConfigs}
      isPasting={isPasting}
    />
  );
};
